<template>
  <v-main fluid class="pa-0 fill-height grey lighten-3">
    <div style="position:absolute;top:12px;left:12px;">
      <router-link to="/">
        <v-img :src="`${Utility.RES_SERVER}/static/img/logo.png`" width="180" contain></v-img>
      </router-link>
    </div>
    <v-row style="margin-top:120px;" justify="center">
      <v-col cols="3">
        <v-card tile style="opacity: 0.9;">
          <v-card-title class="mb-4">欢迎登录中科生信云平台</v-card-title>
          <v-card-subtitle v-if="errMsg" class="red--text">{{errMsg}}</v-card-subtitle>
          <v-card-text>
            <login-form v-if="loginMode==1" ref="loginForm" :login-verify-code="loginVerifyCode" @login="onLogin"></login-form>
            <sms-code-login-form v-if="loginMode==2" :login-verify-code="loginVerifyCode" ref="smsCodeLoginForm" @login="onLogin"></sms-code-login-form>
          </v-card-text>

          <v-card-actions>
            <v-row>
              <v-col cols="12" class="pl-6 pr-6">
                <v-btn block @click="onLogin" tile color="primary" v-one-click>登 录</v-btn>
              </v-col>
              <v-col cols="12" class="pl-6 pr-6">
                <v-row no-gutters>
                  <v-col cols="4">
                    <v-icon color="green" class="mr-1">mdi-wechat</v-icon>
                    <a class="text-decoration-none caption" @click="onWechatLogin">微信</a>
                  </v-col>
                  <v-col cols="8" class="text-right">
                    <a v-if="loginMode==1" class="text-decoration-none caption" @click="loginMode=2">短信验证码登录</a>
                    <a v-if="loginMode==2" class="text-decoration-none caption" @click="loginMode=1">密码登录</a>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" class="text-right">
                <router-link to="/forgot" class="text-decoration-none caption ml-4">忘记密码?</router-link>
                <span class="caption ml-2">|</span>
                <router-link to="/registry" class="text-decoration-none caption ml-2 mr-4">快速注册</router-link>
              </v-col>
            </v-row>

          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-footer dark absolute>
      <span>© 2004 - 2019 上海中科新生命生物科技有限公司 版权所有</span>
      <v-spacer></v-spacer>
      <div>沪ICP备14033860号</div>
    </v-footer>
  </v-main>
</template>
<script>
/* eslint-disable no-console */
import LoginForm from './LoginForm.vue';
import SmsCodeLoginForm from './SmsCodeLoginForm.vue';
import { userLogin, getApplicationValue, getOauthRedirectUrl } from '@/plugins/api';
import Vue from 'vue';
export default {
  data () {
    return {
      errMsg: '',
      loginVerifyCode: false,
      loginMode: 1
    }
  },
  created () {
    window.location.href = window.location.origin + `/plus/#/login`
    this.$store.commit('setToken', null);
    Vue.ls.remove('token');
    getApplicationValue({ loading: false }).then(res => {
      this.loginVerifyCode = res.data && res.data.loginVerifyCode;
    });
  },
  components: { LoginForm, SmsCodeLoginForm },
  methods: {
    onLogin () {
      let redirect = (this.$route.query && this.$route.query.redirect) || '/';
      let loginForm = this.loginMode == 1 ? this.$refs.loginForm : this.$refs.smsCodeLoginForm;
      let validRst = loginForm.validate();
      if (validRst !== true) {
        this.errMsg = validRst;
        return;
      }
      let loginData = loginForm.getLoginData();
      loginData.mode = this.loginMode;
      let wxUnionId = sessionStorage.getItem('wxUnionId');
      let wxPfOpenId = sessionStorage.getItem('wxPfOpenId');
      loginData.wxUnionId = wxUnionId;
      loginData.wxPfOpenId = wxPfOpenId;
      userLogin(loginData).then(res => {
        if (res.status < 0) {
          this.errMsg = res.message;
          return;
        }
        let lu = res.data;
        Vue.ls.set('token', lu.token, lu.expireSeconds * 1000);
        this.$store.commit('setToken', lu.token);
        let pwdChgFlag = lu.pwdChgFlag;
        if (!pwdChgFlag) this.$router.push('/first/guide');
        else this.$router.push(redirect);
      })
    },
    onWechatLogin () {
      getOauthRedirectUrl('biocloud').then(res => window.open(res.data))
    }
  }
}
</script>